const sysRoles = {
  operator: "operator",
  viewer: "viewer",
};

export default sysRoles;
